export default `float a=p.z*.1;
    p.xy *= mat2(cos(a),sin(a),-sin(a),cos(a));
    return abs(.1-length(cos(p.xy)+sin(p.yz)));
  }`